module.exports = __webpack_public_path__ + "static/media/intro-bg-camera.317a63d9.svg";